import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';

import PeriodSummary from "@/components/PeriodSummary";
import GoalInfo from '@/components/GoalInfo';

const useStyles = makeStyles(() => ({
  noScoring: {
    padding: '20px 0',
  }
}))

function ScoringSummary({ goals, periods, players, teams }) {
  const classes = useStyles();

  return Object.keys(goals).map(key => {
    const period = periods[key];
    const periodGoals = goals[key];

    return (
      <PeriodSummary key={key} period={period.name}>
        {!periodGoals.length ?
          <Typography align="center" className={classes.noScoring}>No Scoring</Typography> :
          periodGoals.map(goal => (
            <GoalInfo key={goal.id} goal={{ ...goal, period: period.name }} players={players} teams={teams} />
          ))
        }
      </PeriodSummary>
    )
  })
}

export default ScoringSummary;
